/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import {
    CallReportState,
    CallReportMutations,
    CallReportActions,
    CallReportGetters,
    CallReportFilter,
    FilterItem,
} from '@/types';

const getDefaultState = () => {
    return {
        filter: {
            type: null,
            status: null,
            user: null,
            number: null,
            serviceTimeRange: null,
        },
    } as CallReportState;
};

const state: CallReportState = getDefaultState();

const mutations: MutationTree<CallReportState> = {
    [CallReportMutations.SET_FILTER](state, payload: CallReportFilter) {
        state.filter.type = payload.type;
        state.filter.status = payload.status;
        state.filter.user = payload.user;
        state.filter.number = payload.number;
        state.filter.userLabel = payload.userLabel;
        state.filter.serviceTimeRange = payload.serviceTimeRange;
    },
    [CallReportMutations.CLEAR_FILTER](state, field?: string) {
        switch (field) {
            case 'type':
                state.filter.type = getDefaultState().filter.type;
                break;
            case 'status':
                state.filter.status = getDefaultState().filter.status;
                break;
            case 'user':
                state.filter.user = getDefaultState().filter.user;
                break;
            case 'userLabel':
                state.filter.userLabel = getDefaultState().filter.userLabel;
                break;
            case 'number':
                state.filter.number = getDefaultState().filter.number;
                break;
            case 'serviceTimeRange':
                state.filter.serviceTimeRange = getDefaultState().filter.serviceTimeRange;
                break;
            default:
                state.filter.type = getDefaultState().filter.type;
                state.filter.status = getDefaultState().filter.status;
                state.filter.user = getDefaultState().filter.user;
                state.filter.userLabel = getDefaultState().filter.userLabel;
                state.filter.number = getDefaultState().filter.number;
                state.filter.serviceTimeRange = getDefaultState().filter.serviceTimeRange;
        }
    },
};

const actions: ActionTree<CallReportState, any> = {
    [CallReportActions.SET_FILTER]: ({ commit }, filter: CallReportFilter) =>
        commit(CallReportMutations.SET_FILTER, filter),
    [CallReportActions.CLEAR_FILTER]: ({ commit }, filter: CallReportFilter) =>
        commit(CallReportMutations.CLEAR_FILTER, filter),
};

const getters: GetterTree<CallReportState, any> = {
    [CallReportGetters.DEFAULT_FILTER]: (): CallReportFilter => getDefaultState().filter,
    [CallReportGetters.FILTER]: (state): CallReportFilter => state.filter,
    [CallReportGetters.ACTIVE_FILTERS](state): FilterItem[] {
        const filters: Array<FilterItem> = [];

        if (state.filter.type)
            filters.push({
                field: 'type',
                value: state.filter.type.value,
                label: state.filter.type.label,
            });

        if (state.filter.status)
            filters.push({
                field: 'status',
                value: state.filter.status.value,
                label: state.filter.status.label,
            });

        if (state.filter.user)
            filters.push({
                field: 'user',
                value: state.filter.user.id,
                label: state.filter.user.name,
            });

        if (state.filter.userLabel)
            filters.push({
                field: 'userLabel',
                value: state.filter.userLabel.id,
                label: state.filter.userLabel.label,
            });

        if (state.filter.number)
            filters.push({
                field: 'number',
                value: state.filter.number.id,
                label: state.filter.number.number,
            });

        if (state.filter.serviceTimeRange)
            filters.push({
                field: 'serviceTimeRange',
                value: state.filter.serviceTimeRange.value,
                label: state.filter.serviceTimeRange.label,
            });

        return filters;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};
